import React from "react";
import { useParams } from "react-router-dom";
import VoiceLogs from "components/LM/Voice/Log/VoiceLogs";

const VoicesLogs = () => {
  const { id } = useParams();
  return <VoiceLogs voiceId={id} />;
};

export default VoicesLogs;
